// extracted by mini-css-extract-plugin
module.exports = {"ORDER_RECEIVED":"ORDER_RECEIVED-b8c8e4c5d4807974b3dccf8e9c8c18de"};